import { matchPath } from "react-router-dom";
import {
  FAILED_DOMAIN_STATUSES,
  SUCCESS_DOMAIN_STATUSES,
  VERIFYING_DOMAIN_STATUSES,
} from "../constants";
import { LANGUAGES_ARRAY } from "../constants/languages";
import { FileEarmark, Folder, Star } from "react-bootstrap-icons";
import { Trans, TransProps } from "react-i18next";
import { ReactElement } from "react";

export const TransElement = Trans as (
  props: TransProps<string>
) => ReactElement;

export enum Error {
  UNIQUE_URL = "Response not successful: Received status code 400",
  PAGE_LIMIT = "You can only create 100 pages.",
  NOT_FOUND_PAGE = "Page not found",
  PUBLISH_LIMIT = "Publish limit",
}

export enum FREE_LIMIT {
  PROJECT = 1,
  PAGE = 100,
  SHARE = 10,
  PUBLISHED_PAGE = 5,
  TEMPLATES = 5,
}

export function detectLocaleFromUrl(): string | null {
  const path = window.location.pathname;
  const localeMatch = matchPath({ path: "/:locale/*" }, path);

  const locale = localeMatch?.params?.locale;

  if (locale && LANGUAGES_ARRAY.includes(locale)) {
    return locale;
  }

  return null;
}

export enum ITEMS {
  DOMAIN = "domain",
  FOLDER = "folder",
  PAGE = "page",
  FILES = "files",
}

export enum PAYMENT_STATUS {
  FAILED = -1,
  PENDING = 0,
  COMPLETED = 1,
  CANCELED = 3,
  LOADING = 4,
}

export const ACTIVE_TAB = {
  PROJECTS: "projects",
  FOLDERS: "folders",
  PAGES: "pages",
} as const;

export enum MIGRATE_STATUS {
  PENDING = "pending",
  PROCESSING = "processing",
  DONE = "done",
  FAILED = "failed",
}

export const MIGRATE_STATUS_COLOR: Record<MIGRATE_STATUS, string> = {
  [MIGRATE_STATUS.PENDING]: "#adb5bd",
  [MIGRATE_STATUS.PROCESSING]: "#3a83f6",
  [MIGRATE_STATUS.DONE]: "#4caf50",
  [MIGRATE_STATUS.FAILED]: "#f44336",
};

export enum MIGRATE_STEPS {
  FILES = "files",
  PAGES = "pages",
  FOLDES = "folders",
  DOMAINS = "domains",
  USER_ACCESS = "user_access",
  STORAGE = "storage",
}

export const MIGRATE_STEP_LABELS = Object.fromEntries(
  Object.values(MIGRATE_STEPS).map((step) => [
    step,
    step.charAt(0).toUpperCase() + step.slice(1),
  ])
) as Record<MIGRATE_STEPS, string>;

export const SHARE_TABS = [
  {
    id: 1,
    name: "projects",
    Icon: Star,
  },
  {
    id: 2,
    name: "folders",
    Icon: Folder,
  },
  {
    id: 3,
    name: "pages",
    Icon: FileEarmark,
  },
];

export const getDomainStatus = (status: string) => {
  if (VERIFYING_DOMAIN_STATUSES.includes(status))
    return { className: "text-warning", text: "Verifying" };
  if (FAILED_DOMAIN_STATUSES.includes(status))
    return { className: "text-danger", text: "Failed" };
  if (SUCCESS_DOMAIN_STATUSES.includes(status))
    return { className: "text-success", text: "Connected" };
  return { className: "text-warning", text: "Verifying" };
};

export const simulateClickOnSupportChat = () => {
  const iframe = document.querySelector('iframe[name="helpcrunch-iframe"]');
  if (!iframe) {
    return;
  }

  window.HelpCrunch("openChat");
};

export const formatDateTimeToMinutes = (value: string): string =>
  new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
    .format(new Date(value))
    .replace(",", "");

export const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const SHORT_DAYS: Record<string, string> = {
  Monday: "Mon",
  Tuesday: "Tue",
  Wednesday: "Wed",
  Thursday: "Thu",
  Friday: "Fri",
  Saturday: "Sat",
  Sunday: "Sun",
};

export const SCHEDULE_FILE_FORMATS =
  ".jpg,.jpeg,.png,.pdf,.vcf,.vcard,.mp4,.mpeg,.ogg,.mp3,.au,.snd,.aif,.aifc,.aiff,.mjs,.pcr,.ppt,.pptm,.pptx,.rtf,.xlsx,.xlsm,.xls,.csv";
